import { useDispatch } from "react-redux";

import { Typography, Box } from "@mui/material";

import { Loading } from "classes/Loading";

import { LineItemNumericCalculatorField } from "components/formFields/LineItemNumericCalculatorField";
import { LineItemText } from "components/formFields/LineItemText";
import { LineSkeleton } from "components/formFields/LineSkeleton";
import { LineTableCell } from "components/formFields/LineTableCell";

import { i18n } from "services/i18nService";

import { openAlert } from "globalState/alertSlice";

import { DEFAULT_DECIMALS_UNROUNDED } from "appConstants";
import { LINE_ITEM_METADATA } from "editConfig";

export function LineNewQuantityWithLot(props) {
  const {
    value,
    lotTracked,
    lot,
    lots,
    quantityDiff,
    onValueChange,
    onValueWithLotChange,
    objectType,
    error,
    disabled = false,
    lineReadOnly = false,
    lineNumber,
    item,
  } = props;
  const dispatch = useDispatch();

  const isLoading = value instanceof Loading;
  const isLotOnhandLoading = lotTracked && !lot?.onhand && !Array.isArray(lots);

  function getLotNewQuantity() {
    if (lot.onhand) {
      return lot.onhand.plus(quantityDiff);
    }
    const foundLot = lots.find(({ id }) => id === lot.id);
    if (!foundLot) {
      const message = i18n("lots.LineItemLotNotFound", {
        lotName: lot.name,
        lineNumber,
        itemName: item.name,
      });
      dispatch(openAlert({ type: "error", message }));
      return null;
    }
    return foundLot.onhand.plus(quantityDiff);
  }

  return (
    <LineTableCell sx={{ minWidth: lotTracked && lot ? "8rem" : "5.5rem" }}>
      {isLoading ? (
        <LineSkeleton />
      ) : (
        <>
          {lotTracked ? (
            <>
              <LineItemText
                decimal
                decimalPlaces={DEFAULT_DECIMALS_UNROUNDED}
                value={value}
                dataTesting="lineOnHand"
                sx={{ color: "staticTableCellText" }}
              />
              {lot && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    pl: 1,
                  }}
                >
                  <Typography sx={{ fontSize: "0.8125rem" }}>
                    {i18n("columns.colon.Lot")}
                  </Typography>
                  {isLotOnhandLoading ? (
                    <LineSkeleton sx={{ flexGrow: 1 }} />
                  ) : (
                    <LineItemNumericCalculatorField
                      name="newLotQuantity"
                      value={getLotNewQuantity()}
                      disabled={disabled}
                      lineReadOnly={lineReadOnly}
                      onValueChange={onValueWithLotChange}
                      metadata={LINE_ITEM_METADATA[objectType].newQuantity}
                      error={error}
                    />
                  )}
                </Box>
              )}
            </>
          ) : (
            <LineItemNumericCalculatorField
              name="newQuantity"
              value={value}
              disabled={disabled}
              lineReadOnly={lineReadOnly}
              onValueChange={onValueChange}
              metadata={LINE_ITEM_METADATA[objectType].newQuantity}
              error={error}
              dataTesting="lineNewQuantity"
            />
          )}
        </>
      )}
    </LineTableCell>
  );
}
